import { createApiClient } from '@codesocietyou/contentedge-cms-sdk';
import { getRuntimeConfig, hasValidCmsConfig } from '../config/runtimeConfig';

export function initSdk(): void {
    const config = getRuntimeConfig();

    if (!hasValidCmsConfig(config)) {
        console.warn('ContentEdge CMS SDK was not initialized because CMS runtime config is missing or invalid.');
        return;
    }

    const { CMS_API_URL, CMS_FILE_API_URL, CMS_API_PUBLIC_KEY, TENANT_NAME } = config;
    createApiClient({
        baseUrl: CMS_API_URL,
        fileBaseUrl: CMS_FILE_API_URL,
        apiKey: CMS_API_PUBLIC_KEY,
        tenant: TENANT_NAME,
    });
}
